import React from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { ObjectModel } from '@types';
import { getFileExtensionByUrl } from '@utils';
import { ModelLabel } from '@modules/models';
import { LineItem } from '@components/line-items';
import { NonCadSizes } from './non-cad-sizes';
import { DetailsBox } from './details-box';

import styles from './non-cad-details.module.scss';

interface Props {
    model: ObjectModel;
}

export const NonCadDetails: React.FC<Props> = ({ model }) => {
    const fileExtension = getFileExtensionByUrl(model.title); // TODO model.extension?
    const { t } = useTranslation();
    return (
        <DetailsBox className={cn(styles.box, 'fade-in')}>
            <div className="fade-in">
                <ModelLabel className={styles.title} label={model?.title} />
                <NonCadSizes model={model} />
                <LineItem label={t('labels.format', 'Format')} value={fileExtension} />
            </div>
        </DetailsBox>
    );
};
